<template>
  <div class="processschema-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('processschema_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-vector-polyline</v-icon>{{$t('process.processesschema')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <ProcessschemaFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
          <template slot="item.updated" slot-scope="{ item }">
            {{ formatDateTime(item['updated'], 'long') }}
          </template>
          <template slot="item.services" slot-scope="{ item }">
            <div id="services">
            <v-chip v-for="service in item['services']" :key="service.id"
              class="ma-1 font-weight-bold"
              color="secondary"
            >
              {{ service.name }}
            </v-chip>
          </div>
          </template>
            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import ProcessschemaFilterForm  from '../../components/processschema/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'ProcessSchemaList',
  servicePrefix: 'ProcessSchema',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    ProcessschemaFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.name'), value: 'name' },
        { text: this.$t('service.services'), value: 'services' },
        { text: this.$t('global.update'), value: 'updated' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
      footer: {
        'itemsPerPageText': "",
      },

    };
  },
  computed: {
    ...mapGetters('processschema', {
      items: 'list'
    }),
    ...mapFields('processschema', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('processschema', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
